module.exports = __webpack_public_path__ + "static/img/Earth.1775563.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/elements/Earth.svg
// module id = 1421
// module chunks = 0